
const endpoints = {
    general: '/general-data/',
    ranking: {
        character: '/player/ranking/',
        guild: '/guild/ranking/'
    },
    guild: {
        detail:'/guild/'
    },
    dashboard: {
        server: {
            stat: '/server/character-stat/'
        }
    }
}

export default endpoints